export const config = {
  // Prefer absolute URLs from env; otherwise use relative in prod and localhost in dev
  API_BASE_URL: (() => {
    const raw = (import.meta.env as any).VITE_API_BASE_URL as string | undefined
    const isAbs = (v?: string) => !!v && /^(https?:)?\/\//i.test(v)
    if (isAbs(raw)) return raw as string
    // Use relative base so Vite/nginx can proxy /api. This also enables cookie-based auth without CORS pain.
    return ''
  })(),
  DEBUG: import.meta.env.DEV,
  APP_NAME: '로또 번호 서비스',
  
  // API Endpoints
  API_ENDPOINTS: {
    // Authentication
    LOGIN: '/api/v1/public/auth/login',
    REGISTER: '/api/v1/public/auth/register',
    
    // Lottery
    LATEST_RESULT: '/api/v1/public/lottery/latest-result',
    LOTTERY_RESULTS: '/api/v1/public/lottery/results',
    NUMBER_ANALYSIS: '/api/v1/public/lottery/statistics',
    
    // User Dashboard
    GENERATED_NUMBERS: '/api/v1/lottery/generated',
    GENERATE_NUMBERS: '/api/v1/lottery/generate',
    SUBSCRIPTION_TIERS: '/api/v1/public/subscription-tiers',
    
    // Announcements
    ANNOUNCEMENTS: '/api/v1/public/announcements'
  }
}

export default config